(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabinat-product-recommendation"]) return;
  try {
    
if (!window.sabinatKitLinkInitialized) {
  window.sabinatKitLinkInitialized = true;

  const kitMarker = document.getElementById('sabinat-kit-product-marker');
  const productTitle = document.querySelector('main h1');

  if (kitMarker && productTitle && !document.querySelector('.sabinat-product-badge--title')) {
    const badge = document.createElement('span');
    badge.className = 'sabinat-product-badge sabinat-product-badge--title';
    badge.textContent = 'Más vendido';
    productTitle.insertAdjacentElement('beforebegin', badge);
  }

  document.querySelectorAll('a').forEach((link) => {
    if (link.textContent?.trim().toLowerCase() === 'ver kit completo') {
      link.setAttribute('href', '/products/kit');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabinat-welcome-popup"]) return;
  try {
    
if (!customElements.get('sabi-welcome-popup')) {
  customElements.define('sabi-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.teaser = this.querySelector('.sabi-welcome__teaser');
      if (!this.dialog) return;
      const skipFromUrl = new URLSearchParams(location.search).get('sabi_skip_popup') === '1';
      let skipForSession = skipFromUrl;
      try {
        if (skipFromUrl) sessionStorage.setItem('sabi-welcome-skip-popup-v1', '1');
        skipForSession = skipForSession || sessionStorage.getItem('sabi-welcome-skip-popup-v1') === '1';
      } catch {}
      if (skipForSession) { this.hidden = true; return; }
      this.key = 'sabi-welcome-dismissed-v1';
      this.open = () => {
        if (this.dialog.open || document.querySelector('dialog[open], [aria-modal="true"]')) return;
        this.lastFocused = document.activeElement;
        this.mountForm();
        this.dialog.showModal();
        this.dialog.focus({ preventScroll: true });
        this.dialog.scrollTop = 0;
        this.teaser.hidden = true;
      };
      this.close = () => this.dialog.close();
      this.querySelectorAll('.sabi-welcome__close, .sabi-welcome__dismiss').forEach(button => button.addEventListener('click', this.close));
      this.teaser.addEventListener('click', this.open);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close(); } });
      this.dialog.addEventListener('close', () => {
        try { localStorage.setItem(this.key, JSON.stringify({ at: Date.now(), pageType: this.dataset.pageType || '' })); } catch {}
        this.teaser.hidden = false;
        this.lastFocused?.focus();
      });
      const forced = new URLSearchParams(location.search).get('sabi_popup') === '1';
      if (forced || this.dataset.preview === 'true') { this.open(); return; }
      let dismissed = 0;
      let dismissedPageType = '';
      try {
        const saved = localStorage.getItem(this.key);
        if (saved) {
          try {
            const state = JSON.parse(saved);
            dismissed = Number(state.at) || 0;
            dismissedPageType = state.pageType || '';
          } catch {
            dismissed = Number(saved) || 0;
          }
        }
      } catch {}
      const productPageFollowUp = this.dataset.pageType === 'product' && dismissedPageType !== 'product';
      if (Date.now() - dismissed < 7 * 86400000 && !productPageFollowUp) { this.teaser.hidden = false; return; }
      let ready = false;
      let shown = false;
      const maybeOpen = () => {
        if (shown || !ready || document.visibilityState !== 'visible') return;
        if (document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open], [aria-modal="true"]')) return;
        this.open();
        shown = this.dialog.open;
      };
      this.scrollHandler = maybeOpen;
      window.addEventListener('scroll', maybeOpen, {passive:true});
      this.timer = setTimeout(() => { ready = true; this.teaser.hidden = false; maybeOpen(); }, Number(this.dataset.delay || 5) * 1000);
    }
    mountForm() {
      if (!this.dataset.formUrl || this.mounted) return;
      let url;
      try { url = new URL(this.dataset.formUrl); } catch { return; }
      if (url.protocol !== 'https:') return;
      const frame = document.createElement('iframe');
      frame.src = url.href;
      frame.title = 'Registro de bienvenida de SabiNatura';
      this.querySelector('.sabi-welcome__embed').append(frame);
      this.querySelector('.sabi-welcome__embed').hidden = false;
      this.mounted = true;
    }
    disconnectedCallback() { clearTimeout(this.timer); window.removeEventListener('scroll', this.scrollHandler); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!window.sabinatQuickViewInitialized) {
  window.sabinatQuickViewInitialized = true;

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-sabinat-quick-view-open]');

    if (trigger) {
      const dialog = document.getElementById(`sabinat-quick-view-${trigger.dataset.sabinatQuickViewOpen}`);

      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    if (target.matches('.sabinat-quick-view')) target.close();
  });
}

  } catch(e) { console.error(e); }
})();
})();
